import { useEboxAssetClickHandler } from 'components/widgets/CardView/Collection/CollectionCard/hooks/useEboxAssetClickHandler/useEboxAssetClickHandler';
import { isValidExternalProviders } from 'components/widgets/RailV2/CollectionRail/guards/isValidExternalProviders';

export function useExternalProviderClickHandler(
  externalProvider: string | undefined,
  defaultHandler: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void,
) {
  const eboxProviderClickHandler = useEboxAssetClickHandler();

  if (!externalProvider || !isValidExternalProviders(externalProvider)) {
    return defaultHandler;
  }

  const clickHandlerMap = {
    ebox: eboxProviderClickHandler,
  };

  return clickHandlerMap[externalProvider] ?? defaultHandler;
}
